import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { customAPIRequest } from '../auth/util/util';
import { loaderActions } from '../actions/loaderActions';
import Loader from './Loader';
import { Grid, Paper } from '@mui/material';
import Header from './Header';
import "./MyCourses.css"
import { moodleAppBaseUrl } from '../auth/util/CustomConstants';
import coursePageBg from "../../assets/courses.png"
import { set } from 'date-fns';
import { ca } from 'date-fns/locale';


function MyCourses() {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [courses, setCourses] = useState([]);
    const [userMoodleID, setUserMoodleID] = useState("");
    const userEmail = localStorage.getItem("email") || null;
    const [topCategories, setTopCategories] = useState({
        5: "DIY STEM",
        8: "Coding",
        58: "Tinkering",
    });
    const NO_OF_GRADES = 12;
    const [categories, setCategories] = useState({});
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedGrade, setSelectedGrade] = useState("");
    const [filteredCourses, setFilteredCourses] = useState([]);

    // update this array with the wordpress/other courses you want to display on the page
    const wordpressCourses = [
        {
            id: 1,
            url: "https://www.mysphere.net/courses/computer-science-it/",
            title: "Computer Science & IT",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Computer-Science-IT-300x169.png"
        },
        {
            id: 2,
            url: "https://www.mysphere.net/courses/design-fine-arts/",
            title: "Design & Fine Arts",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Design-Fine-Arts-300x169.png"
        },
        {
            id: 3,
            url: "https://www.mysphere.net/courses/business-management/",
            title: "Business Management",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Business-Management-300x169.png"
        },
        {
            id: 4,
            url: "https://www.mysphere.net/courses/humanities/",
            title: "Humanities",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Humanities-300x169.png"
        },
        {
            id: 5,
            url: "https://www.mysphere.net/courses/engineering-technology/",
            title: "Engineering & Technology",
            image: "https://www.mysphere.net/wp-content/uploads/2022/12/Engineering-Technology.png"
        },
        {
            id: 6,
            url: "https://www.mysphere.net/courses/finance/",
            title: "Finance",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Finance-300x169.png"
        },
        {
            id: 7,
            url: "https://www.mysphere.net/courses/health-fitness/",
            title: "Health & Fitness",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Health-Fitness-300x169.png"
        },
        {
            id: 8,
            url: "https://www.mysphere.net/courses/personal-development/",
            title: "Personal Development",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Personal-Development-300x169.png"
        },
        {
            id: 9,
            url: "https://www.mysphere.net/courses/hospitality/",
            title: "Hospitality",
            image: "https://www.mysphere.net/wp-content/uploads/2022/09/Career-page-1640-×-924-px-300x169.jpg"
        },
        {
            id: 10,
            url: "https://www.mysphere.net/coder/",
            title: "Coder",
            image: "https://www.mysphere.net/wp-content/uploads/2024/05/coding-image.png"
        },
        {
            id: 11,
            url: "https://www.mysphere.net/courses/critical-thinking/",
            title: "Critical Thinking",
            image: "https://www.mysphere.net/wp-content/uploads/2023/03/RKM-300x169.jpg"
        },
        {
            id: 12,
            url: "https://www.mysphere.net/tinkering/",
            title: "Tinkering",
            image: "https://www.mysphere.net/wp-content/uploads/2024/05/robotics-1.png"
        },
        {
            id: 13,
            url: "https://www.mysphere.net/diy-stem/",
            title: "DIY STEM",
            image: "https://www.mysphere.net/wp-content/uploads/2024/05/diy-stem-2.png"
        },
    ]

    // applies filter to allCourses based on category and grade selections
    const applyFilter = (category, grade, allCourses) => {
        let filtered = allCourses;
        if (category) {
            filtered = filtered.filter(course => course.parentCategory === category);
        }
        if (grade) {
            filtered = filtered.filter(course => course.grade === parseInt(grade));
        }
        setFilteredCourses(filtered);
        console.log("filtered courses ", filtered);
    };

    // fetch courses from moodle
    const fetchCourses = async (categoriesData) => {

        try {
            if (!userEmail) return;
            const response = await customAPIRequest("core_user_get_users_by_field", { "field": "email", "values[0]": userEmail });
            const userId = response?.data?.[0]?.id;

            if (userId) {
                setUserMoodleID(userId);
                const coursesResponse = await customAPIRequest("core_enrol_get_users_courses", { "userid": userId, "returnusercount": 0 });

                if (coursesResponse?.data?.length) {
                    const coursesArray = coursesResponse.data.map(course => {
                        let parentCategory = null;
                        let grade = null;
                        Object.keys(categoriesData).forEach((categoryId) => {
                            if (categoriesData[categoryId][course.category]) {
                                parentCategory = categoryId;
                                grade = categoriesData[categoryId][course.category];
                            }
                        });
                        return {
                            id: course.id,
                            summary: course.summary,
                            title: course.fullname,
                            progress: Math.round(course.progress),
                            image: course?.overviewfiles?.[0]?.fileurl.replace("/webservice", "") || null,
                            category: course.category,
                            parentCategory: parentCategory,
                            grade: grade,
                        };
                    });
                    setCourses(coursesArray);
                    setFilteredCourses(coursesArray);
                }
            }
        } catch (error) {
            console.error("Error fetching courses: ", error);
        } finally {
            dispatch(loaderActions.stop());
            setLoading(false);
        }
    };

    // function to generate params for the moodle login url
    const paramsGenerator = (objToAct) => {
        return Object.keys(objToAct)
            .map(
                (key) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(objToAct[key])}`
            )
            .join("&");
    };

    // function to take moodle course
    const takeCourse = async (courseId) => {
        try {
            if (!userEmail) return;
            const moodleLoginUrl = await customAPIRequest(
                "auth_userkey_request_login_url",
                { "user[email]": userEmail }
            );
            if (moodleLoginUrl?.data?.loginurl) {
                const wantsParam = {
                    wantsurl: `${moodleAppBaseUrl}course/view.php?id=${courseId}`,
                };
                const paramsForWantsUrl = paramsGenerator(wantsParam);
                const actionLink = `${moodleLoginUrl.data.loginurl}&${paramsForWantsUrl}`
                window.location.href = actionLink;
            } else {
                return;
            }
        } catch (error) {
            console.log("Error in taking course", error);
        }
    };

    const fetchAllCategories = async () => {
        try{
            const categories = {}
            const categoriesResponse = await customAPIRequest("core_course_get_categories");
            console.log("categoriesResponse ", categoriesResponse);

            const categoriesData = categoriesResponse?.data || [];
            if(!categoriesData.length){
                console.error("No categories found");
                return;
            }

            for(let category of categoriesData){
                if(category.depth === 1 && Object.keys(topCategories).includes(category.id.toString())){
                    categories[category.id] = {
                        name: category.name,
                    }
                }else if(category.depth === 2 && categories[category.parent]){
                    categories[category.parent][category.id] = parseInt(category?.name?.slice(-2).trim());
                }
            }

            console.log("final categories ", categories);
            setCategories(categories);
            return categories;
        } catch(error){
            console.error("Error fetching categories: ", error);
            return {};
        }
    }

    useEffect(() => {
        dispatch(loaderActions.start())
        setLoading(true)
        const init = async () => {
            try {
                const categoriesData = await fetchAllCategories();
                await fetchCourses(categoriesData);

            } catch (error) {
                console.log("error func(init) ", error);
            }
        }
        init()
    }, []);

    // updates the title class to add no-animation class if the title fits in the container
    useEffect(() => {
        const titles = document.querySelectorAll('.title');
        titles.forEach((title) => {
            const parent = title.parentElement;
            if (title.getBoundingClientRect().width + 22 <= parent.getBoundingClientRect().width) {
                title.classList.add('no-animation');
            }
        });
    }, [wordpressCourses, courses]);

    return loading ? (
        <Loader />
    ) : (
        <>
            <Header />
            <div className='hero'>
                <div className='hero_text'>
                    <h1>Get started <br />on your <br />learning journey</h1>
                </div>
                <img src={coursePageBg} alt="courses" />
            </div>
            {courses && courses.length !== 0 && // check if user is enrolled in any course
                <div className='section'>
                    <div className="section_title_wrapper">
                        <h2 className='section_title'>My Enrolled Courses</h2>
                    </div>
                    <div className='section_wrapper'>
                        <Grid>
                                <div className='filter_wrapper'>
                                    <div className='category_wrapper'>
                                        <div className='category_title'>Categories: </div>
                                        <select className='category_dropdown' onChange={(e) => { const val = e.target.value; setSelectedCategory(val); applyFilter(val, selectedGrade, courses); }}>
                                            <option value="">All</option>
                                            {Object.keys(topCategories).map((categoryId) => (
                                                <option key={categoryId} value={categoryId}>{topCategories[categoryId]}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='grade_wrapper'>
                                        <div className='grade_title'>Grade: </div>
                                        <select className='grade_dropdown' onChange={(e) => { const val = e.target.value; setSelectedGrade(val); applyFilter(selectedCategory, val, courses); }}>
                                            <option value="">All</option>
                                            {NO_OF_GRADES && Array.from({ length: NO_OF_GRADES }, (_, i) => i + 1).map((grade) => (
                                                <option key={grade} value={grade}>{grade}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                        </Grid>
                        {filteredCourses.length === 0 ? (
                            <p className='no_courses_message'>No courses found for the selected filters.</p>
                        ) : (
                            <Grid className='grid' container spacing={{ xs: 1, sm: 2, md: 1 }} columns={{ xs: 4, sm: 9, md: 16 }}>
                                {filteredCourses.map((course) => (
                                    <Grid item xs={2} sm={3} md={4} key={course.id}>
                                        <Paper className='course_card' key={course.id} onClick={() => takeCourse(course.id)}>
                                            <div className='image_wrapper'>
                                                <img src={course.image || "/logo512.png"} alt={course.title} />
                                            </div>
                                            <div className='title_wrapper'>
                                                <div  className='title'>{course.title}</div>
                                            </div>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </div>
                </div>
            }
            <div className='section'>
                <div className="section_title_wrapper">
                    <h2 className='section_title'>Courses</h2>
                </div>
                <div className='section_wrapper'>
                    <Grid className='grid' container spacing={{ xs: 1, sm: 3, md: 1 }} columns={{ xs: 4, sm: 9, md: 16 }}>
                        {wordpressCourses.map((course) => (
                            <Grid item xs={2} sm={3} md={4} key={course.id}>
                                <Paper className='course_card' key={course.id} onClick={() => window.location.href = course.url}>
                                    <div className='image_wrapper'>
                                        <img src={course.image || "/logo512.png"} alt={course.title} />
                                    </div>
                                    <div className='title_wrapper'>
                                        <div className='title'>{course.title}</div>
                                    </div>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </div>
        </>
    )
}

export default MyCourses